// @ts-nocheck
import { apiPlugin, storyblokInit } from '@storyblok/svelte';
import { PUBLIC_STORYBLOK_ACCESS_TOKEN } from '$env/static/public';
import { PUBLIC_STORYBLOK_REGION } from '$env/static/public';
import { RichTextSchema } from '@storyblok/svelte';
import { get } from 'svelte/store';
import { cachedUrls, isInStoryblokEditMode } from '$lib/stores.js';
import cloneDeep from 'clone-deep';
import { languageTag } from '$lib/../paraglide/runtime.js';

export const mySchema = cloneDeep(RichTextSchema);

mySchema.marks.link = (node) => {
	let lang = languageTag();
	const attrs = { ...node.attrs };

	const { linktype = 'url' } = node.attrs;

	if (linktype === 'story' && attrs.story) {
		let storyUrls = get(cachedUrls);
		if (storyUrls) {
			let storyUrl = storyUrls.find((storyUrl) => storyUrl.id === attrs.story.id);

			if (storyUrl) {
				attrs.href = `/${lang}/${storyUrl.url}`;
			} else {
				attrs.href = `/${lang}/${attrs.href}`;
			}
		} else {
			attrs.href = `/${lang}/${attrs.href}`;
		}
	}

	return {
		tag: [
			{
				tag: 'a',
				attrs
			}
		]
	};
};

export async function useStoryblok(accessToken = null) {
	accessToken = accessToken ? accessToken : PUBLIC_STORYBLOK_ACCESS_TOKEN;
	// console.log(accessToken);
	storyblokInit({
		accessToken: accessToken,
		use: [apiPlugin],
		components: {
			Homepagina: (await import('$lib/../components/content-type-blocks/Homepagina.svelte'))
				.default,
			ContactPagina: (await import('$lib/../components/content-type-blocks/ContactPagina.svelte'))
				.default,
			InspiratiePagina: (
				await import('$lib/../components/content-type-blocks/InspiratiePagina.svelte')
			).default,
			NieuwsPagina: (await import('$lib/../components/content-type-blocks/NieuwsPagina.svelte'))
				.default,
			Overzichtspagina: (
				await import('$lib/../components/content-type-blocks/Overzichtspagina.svelte')
			).default,
			StandaardPagina: (
				await import('$lib/../components/content-type-blocks/StandaardPagina.svelte')
			).default,
			ShopOverzichtPagina: (
				await import('$lib/../components/content-type-blocks/ShopOverzichtPagina.svelte')
			).default,
			VacatureOverzichtPagina: (
				await import('$lib/../components/content-type-blocks/VacatureOverzichtPagina.svelte')
			).default,
			VacaturePagina: (await import('$lib/../components/content-type-blocks/VacaturePagina.svelte'))
				.default,
			BusinessPagina: (await import('$lib/../components/content-type-blocks/BusinessPagina.svelte'))
				.default,
			TweeKolommen: (await import('$lib/../components/nestable-blocks/TweeKolommen.svelte'))
				.default,
			Afbeelding: (await import('$lib/../components/nestable-blocks/Afbeelding.svelte')).default,
			Tekst: (await import('$lib/../components/nestable-blocks/Tekst.svelte')).default,
			Overzicht: (await import('$lib/../components/nestable-blocks/Overzicht.svelte')).default,
			OverzichtLijst: (await import('$lib/../components/nestable-blocks/OverzichtLijst.svelte'))
				.default,
			CallToAction: (await import('$lib/../components/nestable-blocks/CallToAction.svelte'))
				.default,
			CallToActionMetAfbeelding: (
				await import('$lib/../components/nestable-blocks/CallToActionMetAfbeelding.svelte')
			).default,
			Galerij: (await import('$lib/../components/nestable-blocks/Galerij.svelte')).default,
			HeaderMetAfbeelding: (
				await import('$lib/../components/nestable-blocks/HeaderMetAfbeelding.svelte')
			).default,
			HeaderZonderAfbeelding: (
				await import('$lib/../components/nestable-blocks/HeaderZonderAfbeelding.svelte')
			).default,
			LogoGrid: (await import('$lib/../components/nestable-blocks/LogoGrid.svelte')).default,
			Slider: (await import('$lib/../components/nestable-blocks/Slider.svelte')).default,
			Formulier: (await import('$lib/../components/nestable-blocks/Formulier.svelte')).default,
			VideoEmbed: (await import('$lib/../components/nestable-blocks/VideoEmbed.svelte')).default,
			Quote: (await import('$lib/../components/nestable-blocks/Quote.svelte')).default,
			Html: (await import('$lib/../components/nestable-blocks/Html.svelte')).default,
			Team: (await import('$lib/../components/nestable-blocks/Team.svelte')).default,
			UitgelichteItems: (await import('$lib/../components/nestable-blocks/UitgelichteItems.svelte'))
				.default,
			Vacatures: (await import('$lib/../components/nestable-blocks/Vacatures.svelte')).default,
			Contactpersoon: (await import('$lib/../components/nestable-blocks/Contactpersoon.svelte'))
				.default
		},
		apiOptions: {
			https: true,
			cache: {
				clear: 'auto',
				type: 'none'
			},
			region: PUBLIC_STORYBLOK_REGION // "us" if your space is in US region
		}
	});
}
/**
 * @param {{ linktype: string; url: any; cached_url: string }} linkBlok
 */
export function getHref(linkBlok) {
	// console.log(linkBlok);
	// Check if the visual editor from storyblok is opened
	if (get(isInStoryblokEditMode)) {
		return '#a';
	}

	if (linkBlok.linktype === 'url') {
		return linkBlok.url;
	}
	if (linkBlok.linktype === 'story') {
		if (linkBlok.cached_url != 'homepage') {
			if (linkBlok.story?.id) {
				let storyUrls = get(cachedUrls);
				if (storyUrls) {
					let storyUrl = storyUrls.find((storyUrl) => storyUrl.id === linkBlok.story.id);
					if (storyUrl) {
						return '/' + storyUrl.url;
					}
				}
			}
			return linkBlok.story ? '/' + linkBlok.story.full_slug : '/' + linkBlok.cached_url;
		} else {
			return '/';
		}
	}

	return '';
}

export function transform(url, dimensions = '600x400', quality = 80, smart = true) {
	let smartPath = '';
	if (smart) {
		smartPath = '/smart';
	}

	return url + '/m/' + dimensions + smartPath + '/filters:quality(' + quality + ')';
}

export function getCachedCV() {}
